// SidebarItem.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { ChevronDown, ChevronRight } from "lucide-react";
import Icon from "~/components/Icon";
import { UnreadBadge, useTicketUnread } from "~/components/SupportChat/useTicketUnread";

export default function SidebarItem({
  page,
  oppened,
  activeMenu,
  inactiveMenu,
}) {
  const unreadTickets = useTicketUnread((state) => (page.alias === "tickets" ? state.count : 0));
  const isParentActive = page.isActive;
  const isCollapsible = page.children && page.children.length > 0;
  const showSubmenu = isParentActive && isCollapsible;

  const IconComponent = isCollapsible
    ? isParentActive
      ? ChevronDown
      : ChevronRight
    : Icon;

  return (
    <NavLink to={page.path} className="w-full">
      {({ isActive }) => {
        page.isActive = isActive;
        return (
          <div className={isActive ? activeMenu.class : inactiveMenu.class}>
            {page.icon && <IconComponent size={20} name={page.icon} />}
            {oppened && (
              <div
                className={`flex-1 ${
                  isActive ? "text-white" : "text-gray-500"
                }`}
              >
                {page.title}
              </div>
            )}
            <UnreadBadge count={unreadTickets} />
          </div>
        );
      }}
    </NavLink>
  );
}
